import React from 'react';
import { useSelector } from 'react-redux';
import Header from '../_core/HeaderLeft';
import UnderlineLink from '../_core/UnderlineLink';
import LoginMenuItem from 'components/LoginMenuItem';

import Wrapper from '../_core/Wrapper';
import CourseModal from 'components/Courses/CourseModal';

import Footer from '../_core/Footer';
import Seo, { SITE_NAME } from 'components/Seo';
import { getEnvVar } from 'utils/get-env-var';
import SaleBanner from './SaleBanner';
import { TRIAL_DAYS } from 'utils/constants';
import { SubscribeBtn } from 'components/buttons';

import FeaturedCouses from './FeaturedCourses';
import UniversityRigor from './UniversityRigor';
import NotEnterainment from './NotEntertainment';
import FreeTrailBar from './FreeTrialBar';
import AllLevels from './AllLevels';
import MeetJP from './MeetJP';
import PersonalizedFeedback from './PersonalizedFeedback';
import FacebookCommunity from './FacebookCommunity';
import RhythmBot from './RhythmBot';
import FinalWords from './FinalWords';
import Courses from 'components/Courses';
import { BlogLink } from 'components/buttons/BlogBtn';

import Hero from "./Header";
import WhyJP from "../LandingPage/WhyJP";
import SupportedBy from "../LandingPage/SupportedBy";
import PuddinPops from "../LandingPage/PuddinPops";
import Proof from "../LandingPage/Proof";
import styled from 'styled-components';

const navItems = [
    () => <li><UnderlineLink to={`${getEnvVar('ROOT_ROUTE')}/courses`}>Courses</UnderlineLink></li>,
    () => <li><BlogLink /></li>,
    () => <li><LoginMenuItem /></li>,
    () => <li><SubscribeBtn pill small lighterGray>{TRIAL_DAYS > 0 ? '7 Days Free' : 'Join Now'}</SubscribeBtn></li>
];

const CTA = styled(SubscribeBtn)`
    text-transform: none;

    padding: 13px 30px;
    width: 100%;

    max-width: 350px;
    
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000021;

    margin: 30px 0;
    font-size: 20px;

    div {
        font-style: italic;
        font-size: 15px;
    }
`;

const SatisfactionGuarantee = styled.p`
    font-weight: 500;
    color: #666;
    font-size: 14px;
    margin-top: -20px;
`;

const homeDescription = 'Master improvisation on the drums with online drum lessons from JP Bouvet. '
    + 'A proven, step-by-step method that helps drummers of every level unlock real creative freedom.';

const CTAButton = ({ whiteText }) => {
    const isSubscriber = useSelector(state => state.user.userData.isSubscriber);
    
    if (isSubscriber) {
        return null;
    }

    return (
        <>
            <CTA pill large>
                Start Improvising Now!
                {TRIAL_DAYS > 0 ? <div>Try 7 Days Free</div> : <div>Sign Up Now</div>}
            </CTA>
            <SatisfactionGuarantee style={whiteText ? { color: '#fff' }: {}}>100% Satisfaction Guarantee</SatisfactionGuarantee>
        </>
    );
};

const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: getEnvVar('SITE_URL'),
    description: homeDescription,
    founder: {
        '@type': 'Person',
        name: 'JP Bouvet',
        jobTitle: 'Drummer and drum teacher'
    },
    sameAs: [
        'https://www.youtube.com/@JPBouvet',
        'https://www.instagram.com/jpbouvet/',
        'https://www.facebook.com/jpbouvetmusic/'
    ]
};

// /join/:plan renders the homepage behind the join modal, so it is not a page of its own
const Home = ({ noindex = false }) => {
    const isSubscriber = useSelector(state => state.user.userData.isSubscriber);
    const activeSale = useSelector(state => state.sales.sale);
    const hasActiveSaleBanner = activeSale && activeSale.banner_text;

    if (isSubscriber) {
        return <Courses />;
    }

    return (
        <div style={{ overflow: 'hidden'}}>
            <Seo
                title="Online Drum Lessons in Improvisation"
                description={homeDescription}
                path="/"
                noindex={noindex}
                jsonLd={homeJsonLd} />
            <SaleBanner />
            <Wrapper>
                <Header
                    navItems={navItems} 
                    hasActiveSaleBanner={hasActiveSaleBanner}
                />
            </Wrapper>
            
            <Hero
                title="MASTER IMPROVISATION ON THE DRUMS"
                subtitle="With the <strong><em>PROVEN</em></strong> method that unlocks creative freedom."
                testimonial="The website took my ability to improvise and increased it tenfold."
                testimonialAuthor="Nicholas H."
                videoId="D9-RpLOX9zQ"
                Button={CTAButton}
                useEmailForm={false}
                hideLogo={true}
                hasActiveSaleBanner={hasActiveSaleBanner}
           />

           <WhyJP Button={CTAButton} overlap={true} />
           <Proof Button={CTAButton} />
           <SupportedBy />
           <PuddinPops Button={CTAButton} />
           <MeetJP Button={CTAButton} />
           <FeaturedCouses />

            <UniversityRigor />
            <NotEnterainment />
            <FreeTrailBar />
            <AllLevels />
            <PersonalizedFeedback />
            <FacebookCommunity />
            <RhythmBot />
            <FinalWords />
            
            <Footer />
            <CourseModal />
        </div>
    );
};

export default Home;